import React from 'react';
import ReactDOM from 'react-dom/client';
import './CSS/Global/index.css';
import './CSS/Colors/plug-digital.css';
import './CSS/Utils/error.css';
import reportWebVitals from './reportWebVitals';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import { loadAppConfig } from './Config/env';
import { bootstrapApplication } from './bootstrap';

const root = ReactDOM.createRoot(document.getElementById('root'));

function renderConfigError(error) {
  root.render(
    <React.StrictMode>
      <main className="app-config-error" role="alert">
        <h1>Configuração indisponível</h1>
        <p>
          Não foi possível carregar o arquivo <code>/Config/env/env.json</code>.
        </p>
        <pre>{error?.message || "Erro desconhecido"}</pre>
      </main>
    </React.StrictMode>,
  );
}

bootstrapApplication(loadAppConfig, () => import('./App'))
  .then(({ default: App }) => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
    reportWebVitals();
  })
  .catch((error) => {
    console.error("[env] Falha ao carregar configuração:", error);
    renderConfigError(error);
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
